// Unwrap all anchors in a string of HTML
export const unwrapAnchors = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  const anchors = div.querySelectorAll("a");

  anchors.forEach((anchor) => {
    anchor.outerHTML = anchor.innerHTML;
  });

  return div.innerHTML;
};
